import socketIOClient from "socket.io-client";

let socket = null;

const getSocket = () => {
  if (!socket) {
    socket = socketIOClient({ transports: ["websocket"] });
  }
  return socket;
};

export default getSocket;
